import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectMemberAdded } from 'api/notifications/meta';
import { Strong } from '../basics';
import { Causer } from './causer';
import { UserView } from './user-view';

export const ProjectMemberAddedView: FC<{
  meta: ProjectMemberAdded;
}> = ({ meta: { by, user } }) => (
  <FormattedMessage
    id="notifications.messages.project_member_added"
    values={{
      causer: <Causer user={by} />,
      user:
        (user.firstName != null && !user.firstName.includes('@')) ||
        user.lastName != null ? (
          <UserView user={user} strong includeCompany={user.company != null} />
        ) : (
          <Strong>{user.emailId}</Strong>
        ),
    }}
  />
);
